package com.anjuros.website.templates.selection.components.contactform

import androidx.compose.runtime.mutableStateOf
import com.anjuros.website.components.language.ResKey
import kotlinx.browser.window
import org.w3c.fetch.Headers
import org.w3c.fetch.RequestInit
import org.w3c.xhr.FormData
import kotlin.js.json

const val FORM_ENDPOINT = "https://submit-form.com/aXeBESvbH"
const val SITE_KEY = "0x4AAAAAADxTxIwB04h5ZxyO"
const val CLIENT_ID = "stw01"

class ContactFormViewModel(contactItemsList: List<ContactFormInfo>, val isDemo: Boolean) {


    var contactFormState = mutableStateOf(
        ContactFormState(
            contactItemsList = contactItemsList,
            isSuccess = null,
            isLoading = false
        )
    )


    fun onContactItemChanged(newItem: ContactFormInfo, text: String) {
        contactFormState.value =
            contactFormState.value.copy(
                isSuccess = null,
                contactItemsList = contactFormState.value.contactItemsList.map { item ->
                    if (item.index == newItem.index) {
                        item.copy(
                            inputText = text,
                            errorMessage = null
                        )
                    } else {
                        item
                    }
                }
            )

    }


    private fun validation(): Boolean {
        var validated = true


        contactFormState.value =
            contactFormState.value.copy(
                contactItemsList = contactFormState.value.contactItemsList.map { item ->
                    val results = item.validate()
                    if (validated) {
                        validated = results.all { it.isValid }
                    }

                    item.copy(errorMessage = results.find { !it.isValid }?.message)
                }
            )


        return validated
    }


    fun onSubmit() {

        if (!contactFormState.value.isLoading) {


            if (validation()) {
                val token = js("window.turnstileToken") as String?

                if (token == null && !isDemo) {
                    contactFormState.value = contactFormState.value.copy(
                        spamValidationError = ResKey.CONTACT_VALIDATION_SPAM
                    )
                } else {
                    contactFormState.value = contactFormState.value.copy(
                        isLoading = true
                    )
                    val list: List<Pair<String, String>> = contactFormState.value.contactItemsList
                        .filter { it.inputText.isNotEmpty() }.map{ it.nameText to it.inputText }

                    val payload = json(
                        "display" to json(  *list.toTypedArray()),
                        "cf-turnstile-response" to token,
                        "hidden" to json("client_id" to CLIENT_ID),
                        //"_email.subject" to "Test email subject"
                    )

                    val headers = Headers().apply {
                        append("Accept", "application/json")
                        append("Content-Type", "application/json")
                    }



                    if (isDemo) {
                        contactFormState.value = contactFormState.value.copy(
                            isSuccess = true,
                            isLoading = false,
                            contactItemsList = contactFormState.value.contactItemsList.map { item ->
                                item.copy(
                                    inputText = "",
                                )
                            }
                        )
                    } else {
                        window.fetch(
                            input = FORM_ENDPOINT,
                            init = RequestInit(
                                method = "POST",
                                headers = headers,
                                body = JSON.stringify(payload)
                            )
                        ).then { response ->
                            resetTurnstileToken()
                            if (response.ok) {
                                contactFormState.value = contactFormState.value.copy(
                                    isSuccess = true,
                                    isLoading = false,
                                    contactItemsList = contactFormState.value.contactItemsList.map { item ->
                                        item.copy(
                                            inputText = "",
                                        )
                                    },
                                    spamValidationError = null
                                )


                            } else {
                                contactFormState.value = contactFormState.value.copy(
                                    isSuccess = false,
                                    isLoading = false
                                )
                            }
                        }
                    }
                }
            }
        }
    }

}

fun resetTurnstileToken(){
    js("window.turnstileToken = null")
    js("turnstile.reset()")
}

data class ContactFormState(
    val contactItemsList: List<ContactFormInfo> = emptyList(),
    val isSuccess: Boolean? = null,
    val isLoading: Boolean = false,
    val spamValidationError: ResKey? = null
)